export default "__VITE_ASSET__DYdk5U52__"